import { render } from "./StoreHeader.vue?vue&type=template&id=196d60b7"
import script from "./StoreHeader.vue?vue&type=script&lang=js"
export * from "./StoreHeader.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Project\\UGit\\heronlink\\web\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__